/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Extra_Ask_AnsweredInputs */

const en_us2_coach_extra_ask_answered = /** @type {(inputs: Coach_Extra_Ask_AnsweredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Answered`)
};

const pt_br2_coach_extra_ask_answered = /** @type {(inputs: Coach_Extra_Ask_AnsweredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Respondido`)
};

const es_419_coach_extra_ask_answered = /** @type {(inputs: Coach_Extra_Ask_AnsweredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Respondida`)
};

const pt_pt2_coach_extra_ask_answered = /** @type {(inputs: Coach_Extra_Ask_AnsweredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Respondida`)
};

const fr_fr2_coach_extra_ask_answered = /** @type {(inputs: Coach_Extra_Ask_AnsweredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Répondu`)
};

const de_de2_coach_extra_ask_answered = /** @type {(inputs: Coach_Extra_Ask_AnsweredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beantwortet`)
};

const it_it2_coach_extra_ask_answered = /** @type {(inputs: Coach_Extra_Ask_AnsweredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risposta data`)
};

/**
* | output |
* | --- |
* | "Answered" |
*
* @param {Coach_Extra_Ask_AnsweredInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_extra_ask_answered = /** @type {((inputs?: Coach_Extra_Ask_AnsweredInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Extra_Ask_AnsweredInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_extra_ask_answered(inputs)
	if (locale === "es-419") return es_419_coach_extra_ask_answered(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_extra_ask_answered(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_extra_ask_answered(inputs)
	if (locale === "de-DE") return de_de2_coach_extra_ask_answered(inputs)
	if (locale === "it-IT") return it_it2_coach_extra_ask_answered(inputs)
	return en_us2_coach_extra_ask_answered(inputs)
});
export { coach_extra_ask_answered as "coach-extra.ask_answered" }